

















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































// import { Component, Prop, Vue } from 'vue-property-decorator';
import Component from "vue-class-component";
import { Prop, Vue, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";

import buildUrl from "build-url";

import { bus } from "@/pages/transitweb/main";

import router from "@/router";

import { endpoints } from "@/endpoints";

import { DatasetState, DensityType } from "@/store/datasets/types";
import { AuthState } from "@/store/auth/types";
import { AssistantState } from "@/store/assistant/types";

import { isNullOrUndefined } from "util";

//import variables from '@/pages/app'

import TermsViewer from "@/components/auth/TermsViewer.vue";

const namespace: string = "datasets";

@Component({
    components: {
        TermsViewer,
    },
})
export default class NavBar extends Vue {
    @State("datasets") datasets!: DatasetState;
    @Action("setDataset", { namespace }) setDataset: any;
    @Action("setDatasetType", { namespace }) setDatasetType: any;
    @Action("datasets/setNav") setNav: any;

    @State("auth") auth!: AuthState;
    @Action("auth/logout") signout: any;
    @Action("auth/MFA_deactivate") deactivate: any;
    @Action("auth/refreshToken") refreshToken: any;
    @Action("datasets/getMetadata") getMetadata: any;

    @Getter("auth/isAuthenticated") isAuthenticated?: boolean;
    @Getter("auth/isAnonymousMode") isAnonymousMode?: boolean;

    @Getter("auth/isAuthenticatedAndMfaActivated")
    isAuthenticatedAndMfaActivated?: boolean;

    @Getter("auth/displayName") displayName!: string;
    @Getter("auth/isMfaRequired") isMfaRequired?: boolean;
    @Getter("auth/isAdmin") isAdmin?: boolean;
    @Getter("auth/isScenarioUser") isScenarioUser!: boolean;
    @Getter("auth/isAcsUser") isAcsUser!: boolean;

    @Getter("auth/isAllowedSensitiveInfo")
    isAllowedSensitiveInfo!: boolean;

    @Getter("auth/isSupplyChainExplorerUser")
    isSupplyChainExplorerUser!: boolean;

    @Getter("auth/isRoadClosureAnalyticsUser")
    isRoadClosureAnalyticsUser!: boolean;

    @Getter("auth/accessTokenLifeMs") accessTokenLifeMs!: any;
    @Getter("auth/accessToken") accessToken!: any;

    @State("assistant") assistant!: AssistantState;
    @Action("assistant/setStandAlone") setStandAlone: any;

    @Getter("assistant/assistantName")
    assistantName!: string;

    @Getter("events/eventDensityType")
    eventDensityType!: DensityType;

    version: string = "";

    // LGA Selector
    lga_items: any[] = [];
    context_lga: string | null = null;

    // Is the list of LGAs currently being loaded?
    isContextReportListLoading: boolean = false;

    // Is a Context Report signed URL currently being generated?
    isContextReportOpening: boolean = false;

    DensityType: any = DensityType;

    resourcesMenuOpen: boolean = false;
    contextReportMenuOpen: boolean = false;
    resourcesMenuCloseTimer: number | null = null;

    beforeDestroy() {
        if (this.resourcesMenuCloseTimer !== null) {
            window.clearTimeout(this.resourcesMenuCloseTimer);
        }
    }

    openResourcesMenu() {
        if (this.resourcesMenuCloseTimer !== null) {
            window.clearTimeout(this.resourcesMenuCloseTimer);
            this.resourcesMenuCloseTimer = null;
        }

        this.resourcesMenuOpen = true;
    }

    scheduleResourcesMenuClose() {
        if (this.resourcesMenuCloseTimer !== null) {
            window.clearTimeout(this.resourcesMenuCloseTimer);
        }

        this.resourcesMenuCloseTimer = window.setTimeout(() => {
            if (!this.contextReportMenuOpen) {
                this.resourcesMenuOpen = false;
            }

            this.resourcesMenuCloseTimer = null;
        }, 200);
    }

    openContextReportMenu() {
        this.contextReportMenuOpen = true;
        this.openResourcesMenu();
    }

    closeContextReportMenu() {
        /*
         * Delay the reset slightly because Vuetify can blur the select while
         * transferring interaction to its detached dropdown menu.
         */
        window.setTimeout(() => {
            this.contextReportMenuOpen = false;
            this.scheduleResourcesMenuClose();
        }, 250);
    }

    user_guide_info = [
        ["user_guide_transitweb", "TraNSIT Web"],
        ["user_guide_dashboard", "Supply Chain Benchmarking Dashboard"],
        //['user_guide_events', this.isAcsUser, 'Event Maps'],
        //['user_guide_scenarios', this.isScenarioUser, 'Scenario Functionality'],
    ];

    showTermsDialog: boolean = false;
    terms_slug: string = "terms-of-service";

    created() {
        // Close Terms Dialog.
        bus.$on("close_terms_dialog", (val: boolean) => {
            this.showTermsDialog = val;
        });
    }

    mounted() {
        Vue.nextTick(() => {
            // Note: needs to be run on next tick so that authentication can complete.

            // Load the list of LGAs.
            this.loadContextReportLGAs();
        });
    }

    get nav(): string {
        return this.datasets.nav;
    }

    set nav(val: string) {
        this.setNav(val);
    }

    deactivate_mfa() {
        var vm = this;

        this.deactivate({})
            .then(function (resp: any) {
                console.log(resp);
                vm.$router.push("/MFA");
            })
            .catch(function (err: any) {
                console.log(err);
            });
    }

    get densityType(): DensityType {
        return this.datasets.type;
    }

    @Watch("nav", { deep: false })
    onNavChanged(val: any, oldVal: any) {
        // Do not react to navigation state changes while logged out.
        // Anonymous mode is allowed to continue using the navigation.
        if (!this.isAuthenticated && !this.isAnonymousMode) {
            return;
        }

        const fromOtherRoute =
            oldVal === "Benchmarking" ||
            oldVal === "Explorer" ||
            oldVal === "RoadClosures";

        if (
            val == DensityType.Road ||
            val == DensityType.Rail ||
            val == DensityType.Sea ||
            val == DensityType.Air
        ) {
            this.setDatasetType(val);

            this.$store.commit("datasets/setLegendUpdate", {
                val,
                oldVal,
            });

            if (fromOtherRoute) {
                this.$router.push("/");
            }
        } else if (val == "Events") {
            this.setDatasetType(this.eventDensityType);

            this.$store.commit("datasets/setLegendUpdate", {
                val,
                oldVal,
            });

            if (fromOtherRoute) {
                this.$router.push("/");
            }
        } else if (!this.assistant.isStandAlone) {
            if (val == "Explorer") {
                this.$router.push("/explorer");
            } else if (val == "Benchmarking") {
                this.$router.push("/benchmark");
            } else if (val == "RoadClosures") {
                this.$router.push("/road-closures");
            }
        }
    }

    @Watch("datasets", { deep: true })
    onDensityTypeChanged(val: any, oldVal: any) {
        if (
            val == DensityType.Road ||
            val == DensityType.Rail ||
            val == DensityType.Sea ||
            val == DensityType.Air
        ) {
            this.nav = val.type;
        }
    }

    @Watch("datasets.dataset")
    onDatasetDefined(val: any, oldVal: any) {
        // Clear the previous Context Report selection because the available
        // LGAs may differ between datasets.
        this.context_lga = null;
        this.lga_items = [];

        this.fetchMetadata();
        this.loadContextReportLGAs();
    }

    @Watch("isAuthenticated")
    onAuthenticated(val: boolean, oldVal: boolean) {
        this.fetchMetadata();

        if (val) {
            // Authentication has completed, so the LGA endpoint can now be
            // requested using the authenticated session.
            this.loadContextReportLGAs();
        } else {
            this.context_lga = null;
            this.lga_items = [];
        }
    }

    fetchMetadata() {
        if (this.datasets.dataset !== undefined && this.isAuthenticated) {
            // Get current baseline metadata.
            this.getMetadata({
                dataset: this.datasets.dataset,
                endpoint_type: "web",
            })
                .then(() => {
                    this.version = this.datasets.metadata.baseline_name;

                    console.log("Version:", this.version);
                })
                .catch((error: any) => {
                    //console.error(error);
                });
        }
    }

    /**
     * Load the available Local Government Areas for the Context Report
     * selector from the boundaries endpoint.
     */
    async loadContextReportLGAs() {
        if (
            !this.isAuthenticated ||
            isNullOrUndefined(this.datasets.dataset) ||
            this.isContextReportListLoading
        ) {
            return;
        }

        this.isContextReportListLoading = true;

        try {
            const response: any = await Vue.axios({
                url: buildUrl(endpoints.boundariesUrl(this.datasets.dataset), {
                    queryParams: {
                        layer: "LGA",
                    },
                }),
            });

            /*
             * The boundaries endpoint normally returns objects containing a
             * name property. String values are also converted into objects so
             * the v-select can consistently use item-text and item-value.
             */
            this.lga_items = (response.data || []).map((item: any) => {
                if (typeof item === "string") {
                    return {
                        name: item,
                    };
                }

                return item;
            });
        } catch (error) {
            console.error("Unable to load Local Government Areas:", error);

            this.lga_items = [];
        } finally {
            this.isContextReportListLoading = false;
        }
    }

    /**
     * Open a Context Report only when the user selects an LGA from the list.
     *
     * Keyboard type-ahead may update the v-select value, but it will not call
     * this method until an item is explicitly selected.
     */
    async onContextReportLGASelected(lga: string) {
        if (!lga || this.isContextReportOpening) {
            return;
        }

        this.context_lga = lga;

        // The detached LGA menu has finished being used.
        this.contextReportMenuOpen = false;

        await this.downloadContextReport();

        this.scheduleResourcesMenuClose();
    }

    /**
     * Generate a signed URL and open the selected Context Report PDF.
     */
    async downloadContextReport() {
        if (!this.context_lga || this.isContextReportOpening) {
            return;
        }

        /*
         * Open the browser window immediately in response to the user's click.
         * Waiting until after the asynchronous signed URL request completes can
         * cause the browser to identify the new window as an unwanted popup.
         */
        const reportWindow = window.open("", "_blank");

        this.isContextReportOpening = true;

        try {
            // Generate signed URL to access Context Report from Google Storage Bucket.
            const response: any = await Vue.axios({
                url: buildUrl(endpoints.contextReportUrl(this.context_lga)),
            });

            if (!isNullOrUndefined(response.data)) {
                const signed_url: string = response.data;

                if (reportWindow) {
                    reportWindow.location.href = signed_url;
                } else {
                    // Fall back to opening the report in the current window if
                    // the browser prevents the new window from being created.
                    window.location.href = signed_url;
                }

                this.trackClick("Context Report");
            } else if (reportWindow) {
                reportWindow.close();
            }
        } catch (error) {
            console.error("Unable to open Context Report:", error);

            if (reportWindow) {
                reportWindow.close();
            }
        } finally {
            this.isContextReportOpening = false;
        }

        //(window as any).open('./docs/acs_context_reports/' + this.context_month + '/' + this.context_lga + '.pdf');
    }

    isTokenExpired: boolean = false;
    timeoutID: any;

    @Watch("auth.access_token", { deep: true })
    onAccessTokenUpdated(val: any, oldVal: any) {
        if (this.isAuthenticated) {
            var exp = this.accessTokenLifeMs(new Date());

            //console.log("Token Expires in:", exp);
            //console.log(this.accessToken)

            clearTimeout(this.timeoutID);
            this.isTokenExpired = false;

            this.timeoutID = setTimeout(async () => {
                console.log("Access Token Expired!");

                this.isTokenExpired = true;

                try {
                    console.log("Refreshing token on expiry...");
                    await this.refreshToken();
                } catch (_error) {}
            }, exp);
        }
    }

    return_assistant() {
        this.setStandAlone(false);
        bus.$emit("assistant_dialog", true);
    }

    onDatasetChanged(val: any) {
        this.setDataset(val);
    }

    async signOut() {
        console.log("Signing Out");

        await this.signout();

        if (this.$route.path !== "/signin") {
            await this.$router.push("/signin");
        }
    }

    trackClick(label: string) {
        (Vue as any).gtm.trackEvent({
            event: "gui",
            category: "links",
            action: "Link Clicked",
            label: label,
            //value: payload.value,
            noninteraction: true,
        });

        //console.log('Link Clicked', label)
    }

    provideFeedback() {
        (window.location as any) =
            "mailto:support@transit.csiro.au?subject=TraNSIT Web Feedback&body=Please tell us about your experience...";

        this.trackClick("Provide Feedback");
    }

    about() {
        (window as any).open("https://www.csiro.au/TRANSIT");
        this.trackClick("About");
    }

    ai_assistant() {
        bus.$emit("assistant", {
            subject: "transit_web",
        });
    }

    newsletter_archives() {
        (window as any).open(
            process.env.VUE_APP_BACKEND_BASE + "/newsletters/",
        );

        this.trackClick("Newsletter Archives");
    }

    news_articles() {
        // Doco on querying the Google Search API here: https://www.google.com/support/enterprise/static/gsa/docs/admin/current/gsa_doc_set/xml_reference/request_format.html

        if (this.nav == "Benchmarking") {
            (window as any).open(
                "https://www.google.com/search?q=%22Supply+Chain+Benchmarking+Dashboard%22&tbs=sbd:1&tbm=nws",
            );
        } else {
            (window as any).open(
                "https://www.google.com/search?q=%22Transport+Network+Strategic+Investment+Tool%22&tbs=sbd:1&tbm=nws",
            );
        }

        this.trackClick("News Articles");
    }

    publications() {
        // Doco on querying the Google Search API here: https://www.google.com/support/enterprise/static/gsa/docs/admin/current/gsa_doc_set/xml_reference/request_format.html

        (window as any).open(
            "https://scholar.google.com.au/scholar?hl=en&as_sdt=0,5&q=%E2%80%9CTransport+Network+Strategic+Investment+Tool%E2%80%9D",
        );

        this.trackClick("Publications");
    }

    metadata() {
        (window as any).open("./docs/commodity_metadata.pdf");
        this.trackClick("Commodity Metadata");
    }

    context_report_guide() {
        (window as any).open(
            "./docs/context_report_placemat_interpretation_guide.pdf",
        );
        this.trackClick("Context Report Placemat Guide");
    }

    faq() {
        (window as any).open("./docs/faq_transitweb.pdf");
        this.trackClick("FAQ");
    }

    transitweb_video() {
        (window as any).open(
            "https://vimeo.com/showcase/12179798?share=copy&fl=sm&fe=fe",
        );

        this.trackClick("TraNSIT Web Video Tutorials");
    }

    user_guide(name: any) {
        (window as any).open("./docs/" + name + ".pdf");
        this.trackClick("User Guide");
    }

    networks() {
        (window as any).open("./docs/transit_networks.pdf");
        this.trackClick("Network Information");
    }

    road_closure_sources_info() {
        bus.$emit("road_closure_sources", true);
    }

    scenario_studio() {
        if (this.$route.name === "Map") {
            bus.$emit("scenario_studio", true);
            return;
        }

        // Scenario Studio's listener lives in TransitMap, so wait for the map route.
        const stopWaiting = this.$router.afterEach(() => {
            stopWaiting();
            this.$nextTick(() => bus.$emit("scenario_studio", true));
        });

        // Setting `nav` highlights the Road Maps button and, via onNavChanged,
        // navigates to the map route — but only when the value actually changes.
        const wasAlreadyRoad = this.nav === this.DensityType.Road;
        this.nav = this.DensityType.Road;

        // Already Road means onNavChanged won't fire, so navigate here instead.
        if (wasAlreadyRoad) {
            this.$router.push({ name: "Map" }).catch(() => stopWaiting());
        }
    }

    task_list() {
        bus.$emit("task_list_dialog", true);
    }

    user_account() {
        this.$router.push("/account");
    }

    get devbuild() {
        return !isNullOrUndefined(process.env.VUE_APP_COMMIT_COUNT);
    }

    get subtitle() {
        return `v0.0.${process.env.VUE_APP_COMMIT_COUNT}-dev`;
    }
}
